<template>
  <div>
    <ElForm inline class="elementui-common-form-styles" v-highlight label-width="62px">
      <ElFormItem>
        <ElInput
          ref="searchInputRef"
          v-model="formFields.keyword"
          :placeholder="searchBoxPlaceholder"
          style="width: 220px"
          clearable
          @keyup.enter.native="onQueryAction"
        >
          <ElSelect v-model="formFields.queryType" @change="onSearchTypeChange" slot="prepend" style="width: 80px">
            <ElOption
              v-for="label in [
                { label: '素材', value: 1 },
                { label: '计划名称', value: 2 }
              ]"
              :key="label.value"
              :value="label.value"
              :label="label.label"
            ></ElOption>
          </ElSelect>
          <i slot="append" @click="onQueryAction" class="el-icon-search"></i>
        </ElInput>
      </ElFormItem>
      <ElFormItem label="媒体" label-width="38px">
        <el-select v-model="formFields.mediaIds" multiple collapse-tags filterable clearable placeholder="选择媒体" style="width: 180px">
          <el-option v-for="label in MEDIAS_LIST" :key="label.value" :value="label.value" :label="label.label"></el-option>
        </el-select>
      </ElFormItem>
      <ElFormItem label="限制媒体">
        <el-select
          v-model="formFields.exludeMediaIds"
          multiple
          collapse-tags
          filterable
          clearable
          placeholder="选择限制媒体"
          style="width: 180px"
        >
          <el-option v-for="label in MEDIAS_LIST" :key="label.value" :value="label.value" :label="label.label"></el-option>
        </el-select>
      </ElFormItem>

      <ElFormItem label="账号名称">
        <ThrottleSelector
          v-model="formFields.accountIds"
          :list="mediaAccountList"
          style="width: 180px"
          placeholder="请选择"
          multiple
          collapse-tags
          filterable
          clearable
        />
      </ElFormItem>

      <ElFormItem label="设计师">
        <ThrottleSelector
          v-model="formFields.designerIds"
          :list="sysUserList"
          style="width: 180px"
          placeholder="请选择"
          multiple
          collapse-tags
          filterable
          clearable
        />
      </ElFormItem>
      <ElFormItem label="广告投放人员" label-width="90px">
        <ThrottleSelector
          v-model="formFields.launchOpIdList"
          :list="sysUserList"
          style="width: 180px"
          placeholder="请选择"
          multiple
          collapse-tags
          filterable
          clearable
        />
      </ElFormItem>
      <ElFormItem label="游戏组">
        <el-select v-model="formFields.gameGroupIds" multiple collapse-tags filterable clearable placeholder="请选择" style="width: 180px">
          <el-option v-for="label in gameGroupList" :key="label.id" :value="label.id" :label="label.name"></el-option>
        </el-select>
      </ElFormItem>
      <ElFormItem label="处理状态">
        <el-select v-model="formFields.recordStatus" clearable placeholder="请选择" style="width: 100px">
          <el-option v-for="label in STATUS_LIST" :key="label.id" :value="label.id" :label="label.name"></el-option>
        </el-select>
      </ElFormItem>

      <ElFormItem label="创建时间">
        <DateRangePicker v-model="formFields.dateRange" style="width: 220px" @change="onQueryAction"></DateRangePicker>
      </ElFormItem>
      <ElFormItem class="bg-transparent">
        <el-button type="primary" @click="onQueryAction" :loading="mediaRejTableLoading">查询</el-button>
      </ElFormItem>
    </ElForm>

    <div class="table-operation-row">
      <el-dropdown trigger="click" @command="openBatchDialog">
        <el-button :disabled="!selectedRows.length">
          批量操作（{{ selectedRows.length }}）<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item :command="BATCH_ACTION.STATUS">批量修改状态</el-dropdown-item>
          <el-dropdown-item :command="BATCH_ACTION.LIMIT_MEDIA">批量限制投放</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button @click="onDownloadAction" :loading="downloadLoading">数据导出</el-button>
    </div>

    <Viewport v-model="tableHeight">
      <el-table
        class="common-el-table-styles"
        v-loading="mediaRejTableLoading"
        :data="rejectionData"
        :height="tableHeight"
        border
        style="width: 100%"
        :cell-class-name="cellClassName"
        @selection-change="onSelectionChange"
      >
        <el-table-column type="selection" width="46" fixed></el-table-column>
        <el-table-column prop="id" label="ID" width="80"> </el-table-column>
        <el-table-column show-overflow-tooltip prop="imageName" label="素材名称" width="220">
          <template slot-scope="{ row }">
            <div style="white-space: pre">{{ row.imageName }}</div>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="material" label="素材" width="120">
          <template slot-scope="{ row }">
            <el-image
              v-if="IMAGE_TYPES.GROUP_IMAGE === row.type"
              v-popover="{ url: row.overviewAddr, type: 'image', height: 320 }"
              style="height: 76px; cursor: pointer"
              :src="row.overviewAddr"
            ></el-image>

            <el-image
              v-else-if="IMAGE_TYPES.IMAGE === row.type"
              v-popover="{ url: row.addr, type: 'image', height: 320 }"
              style="height: 76px; cursor: pointer"
              :src="row.addr"
            ></el-image>

            <el-image
              v-else
              v-popover="{ url: row.field1, type: 'video', height: 320 }"
              style="height: 76px; cursor: pointer"
              :src="row.addr"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="excludeMediaNames" label="限制投放媒体" width="140">
          <template slot-scope="{ row }">
            <div class="exclude-media-cell">
              <template v-if="row.excludeMediaNames">
                <p v-for="name in row.excludeMediaNames.split(',')" :key="name">{{ name }}</p>
              </template>
              <span v-else>-</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="元素" width="90">
          <template slot-scope="{ row }" v-if="row.mediaId === MEDIAS.GDT">
            <template v-if="row.type === IMAGE_TYPES.VIDEO && row.elementInfo.element_reject_detail_info">
              <div v-for="(info, idx) in row.elementInfo.element_reject_detail_info" :key="idx">
                <div v-for="(item, _idx) in info" :key="_idx">
                  <p>违规帧：{{ item.time_second }}s</p>
                  <el-popover popper-class="material-popover" placement="right-start" trigger="hover">
                    <el-image :src="item.img_url" style="height: 340px"></el-image>
                    <p slot="reference"><el-image :src="item.img_url" style="height: 32px"></el-image></p>
                  </el-popover>
                </div>
              </div>
            </template>
            <template v-if="[IMAGE_TYPES.GROUP_IMAGE, IMAGE_TYPES.IMAGE].includes(row.type)">
              <span v-if="imageRejInfoLoading" class="el-icon-loading"></span>
              <template v-if="row.imageRejInfo.preview_url">
                <el-popover popper-class="material-popover" placement="right-start" trigger="hover">
                  <el-image :src="row.imageRejInfo.preview_url" style="height: 340px"></el-image>
                  <p slot="reference"><el-image :src="row.imageRejInfo.preview_url" style="height: 32px"></el-image></p>
                </el-popover>
              </template>
            </template>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="designerName" label="设计师" width="70"> </el-table-column>
        <el-table-column show-overflow-tooltip prop="mediaName" label="媒体" width="70"> </el-table-column>
        <el-table-column show-overflow-tooltip label="处理状态" width="100">
          <template slot-scope="{ row }">
            <el-select
              :key="`${row.id}-${row.recordStatus}-${row.statusVersion}`"
              :value="row.recordStatus"
              :disabled="row.statusUpdating"
              size="mini"
              placeholder="请选择"
              @change="onTableRowStatusChange($event, row)"
            >
              <el-option v-for="item in STATUS_LIST" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="mediaImageId" label="媒体素材ID" width="120"> </el-table-column>
        <el-table-column show-overflow-tooltip prop="adName" label="计划名称" width="200"> </el-table-column>
        <el-table-column show-overflow-tooltip prop="adId" label="计划ID" width="110"> </el-table-column>
        <el-table-column show-overflow-tooltip prop="launchOpName" label="广告投放人员" width="110"> </el-table-column>
        <el-table-column show-overflow-tooltip prop="accountName" label="媒体账号名称" width="110"> </el-table-column>
        <el-table-column show-overflow-tooltip prop="advertiserId" label="计划主ID" width="110"> </el-table-column>
        <el-table-column show-overflow-tooltip prop="rejectReason" label="拒审理由" min-width="250"> </el-table-column>
        <el-table-column prop="createTimeStr" label="创建时间" width="140"> </el-table-column>
      </el-table>

      <div class="pager" style="text-align: right">
        <el-pagination
          :current-page.sync="rejTablePager.pageIndex"
          :page-size.sync="rejTablePager.pageSize"
          :total="rejTablePager.total"
          :page-sizes="[30, 50, 100, 200]"
          @current-change="onQueryTableData"
          @size-change="onQueryAction"
          layout="total, sizes, prev, pager, next, jumper"
          background
        >
        </el-pagination>
      </div>
    </Viewport>

    <MediaRejectionBatchDialog
      :visible.sync="batchDialogVisible"
      :type="batchActionType"
      :selected-count="operationRows.length"
      :status-options="STATUS_LIST"
      :initial-media-ids="initialMediaIds"
      :loading="operationLoading"
      @confirm="submitBatchAction"
    />
  </div>
</template>

<script setup>
import { reactive, ref, set, computed } from 'vue'
import moment from 'moment'
import DateRangePicker from '@/components/date-range-picker'
import { MEDIAS, MEDIAS_LIST } from '@/common/js/constants'
import { IMAGE_TYPES } from '../uploading/consts'
import ThrottleSelector from '@/components/throttle-select/index.vue'
import { useMediaRejections, STATUS_LIST, BATCH_ACTION } from './hooks/useMediaRejections'
import MediaRejectionBatchDialog from './components/media-rejection-batch-dialog.vue'
import { initPageData, MEDIA_ACCOUNTS, SYS_USERS, GAME_GROUPS } from '@/data/global-opts'
import { downloadMaterialRejList, getElementInfoDetail } from '@/api/material.model'
const PAGE_REQUIRED_OPTS = initPageData([MEDIA_ACCOUNTS, SYS_USERS, GAME_GROUPS])
const mediaAccountList = computed(PAGE_REQUIRED_OPTS.MEDIA_ACCOUNTS)
const sysUserList = computed(PAGE_REQUIRED_OPTS.SYS_USERS)
const gameGroupList = computed(PAGE_REQUIRED_OPTS.GAME_GROUPS)
const formFields = reactive({
  keyword: '',
  queryType: 1,
  mediaIds: [],
  exludeMediaIds: [],
  dateRange: [moment().subtract(6, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
  accountIds: [],
  gameGroupIds: [],
  designerIds: [],
  launchOpIdList: [],
  recordStatus: undefined
})
const downloadLoading = ref(false)
const {
  tableHeight,
  rejTablePager,
  mediaRejTableLoading,
  imageRejInfoLoading,
  rejectionData,
  selectedRows,
  batchDialogVisible,
  batchActionType,
  operationRows,
  initialMediaIds,
  operationLoading,
  onQueryTableData,
  onTableRowStatusChange,
  onSelectionChange,
  openBatchDialog,
  submitBatchAction,
  buildParams
} = useMediaRejections(formFields)
const onQueryAction = () => {
  rejTablePager.value.pageIndex = 1
  onQueryTableData()
}
const onSearchTypeChange = () => {
  formFields.keyword = ''
}
const onDownloadAction = () => {
  if (downloadLoading.value) return
  downloadLoading.value = true
  downloadMaterialRejList({ ...buildParams() }).finally(() => (downloadLoading.value = false))
}
const searchBoxPlaceholder = computed(() => {
  if (formFields.queryType === 1) return '请输入素材名称或ID'
  return '请输入计划名称'
})

const cellClassName = ({ row, column }) => {
  if (['material'].includes(column.property)) {
    return 'addr-cell'
  }
}

onQueryAction()
</script>

<style scoped lang="scss">
.table-operation-row {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin: 0 10px 10px;
}

.exclude-media-cell {
  line-height: 18px;
}

::v-deep .addr-cell {
  .cell {
    > span {
      display: block;
      text-align: center;
    }

    .video-material-ref {
      position: relative;
      .el-icon-video-play {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        font-size: 24px;
        line-height: 76px;
        z-index: 10;
        color: #fff;
        opacity: 0.7;
      }
    }
  }
}
</style>
